export interface IFilterSelectItem<T = number> {
  value: T;
  title: string;
  description?: string;
}
